import classNames from "classnames";
import React, {ReactNode} from "react";
import {DropdownItem as BSDropdownItem, DropdownItemProps as BSDropdownItemProps} from "react-bootstrap";
import {BsPrefixRefForwardingComponent} from "react-bootstrap/helpers";
import styles from "./DropdownItem.module.scss";

interface DropdownItemProps extends BSDropdownItemProps {
  children?: ReactNode;
  className?: string;
  variant?: "default" | "link";
}

const DropdownItem: BsPrefixRefForwardingComponent<"a", DropdownItemProps> = React.forwardRef(
  ({children, className = "", variant = "default", ...props}, ref) => {
    return (
      <BSDropdownItem
        className={classNames("custom-dropdown-item", styles.dropdownItem, styles[variant], className)}
        ref={ref}
        variant={variant}
        {...props}
      >
        {children}
      </BSDropdownItem>
    );
  }
) as typeof DropdownItem;

DropdownItem.displayName = "DropdownItem";
export {DropdownItem};
